export default __webpack_public_path__ + "static/media/TimerIcon.9e559d6e.svg";